import React from 'react';
import Form from './components/Form';
import Title from 'components/atoms/Title';
import { TranslatedTextV2 } from 'components/atoms/TranslatedText';
import { TranlsationKey } from './configuration';

const LoginFrom = () => {
  return (
    <div>
      <Title
        style={{ textAlign: 'center' }}
        subTitle={
          <TranslatedTextV2
            defaultText="Sign in with your email"
            translationKey={`${TranlsationKey}.signupSubtitle`}
          />
        }
      >
        <TranslatedTextV2
          defaultText="Sign in"
          translationKey={`${TranlsationKey}.singinTitle`}
        />
      </Title>
      <Form />
    </div>
  );
};

export default React.memo(LoginFrom);
